module.exports = __webpack_public_path__ + "img/gebratenerreisohnehintergrund.e646e2ba.png";